import AnonymousInformationI18nKeys from "./DesktopHeaderControl/AnonymousInformation.i18n";
import CtmInformationI18nKeys from "./DesktopHeaderControl/CtmInformation.i18n";
import DesktopHeaderControlI18nKeys from "./DesktopHeaderControl/DesktopHeaderControl.i18n";
import DotcomDesktopFooterI18nKeys from "./DotcomFooter/DotcomDesktopFooter/DotcomDesktopFooter.i18n";
import DotcomMobileFooterI18nKeys from "./DotcomFooter/DotcomMobileFooter/DotcomMobileFooter.i18n";
import CopyrightI18nKeys from "./DotcomHeader/DotcomHeaderMobile/Copyright.i18n";
import DotcomHeaderMobileI18nKeys from "./DotcomHeader/DotcomHeaderMobile/DotcomHeaderMobile.i18n";
import DotcomMobileHeaderLoginPromptI18nKeys from "./DotcomHeader/DotcomHeaderMobile/DotcomHeaderMobileLoginPrompt/DotcomHeaderMobileLoginPrompt.i18n";
import DotcomHeaderMobileWithGlobalNavI18nKeys from "./DotcomHeader/DotcomHeaderMobileWithGlobalNav/DotcomHeaderMobileWithGlobalNav.i18n";
import DotcomSystemMessagesI18nKeys from "./DotcomSystemMessages/DotcomSystemMessages.i18n";
import LocaleSwitcherI18nKeys from "./LocaleSwitcher/LocaleSwitcher.i18n";
import MobileHeaderControlI18nKeys from "./MobileHeaderControl/MobileHeaderControl.i18n";
import PlacementI18nKeys from "./placements/i18nKeys";
import SearchAutocompleteI18nKeys from "./SearchAutocomplete/SearchAutocomplete.i18n";
import StartupMessageI18nKeys from "./StartupMessage/StartupMessage.i18n";

export default {
  ...AnonymousInformationI18nKeys,
  ...CopyrightI18nKeys,
  ...CtmInformationI18nKeys,
  ...DesktopHeaderControlI18nKeys,
  ...DotcomDesktopFooterI18nKeys,
  ...DotcomHeaderMobileI18nKeys,
  ...DotcomHeaderMobileWithGlobalNavI18nKeys,
  ...DotcomMobileFooterI18nKeys,
  ...DotcomMobileHeaderLoginPromptI18nKeys,
  ...DotcomSystemMessagesI18nKeys,
  ...LocaleSwitcherI18nKeys,
  ...MobileHeaderControlI18nKeys,
  ...PlacementI18nKeys,
  ...SearchAutocompleteI18nKeys,
  ...StartupMessageI18nKeys,
};
